<template>
  <form @submit.prevent="submit">
    <img
      class="mb-5"
      src="@/assets/logo.png"
      style="height: 7.5rem;"
    />
    <hr />
    <h1 class="h3 mb-3 fw-normal">Enter the code you received in email.</h1>

    <div class="form-floating mb-1">
      <input
        type="text"
        class="form-control"
        id="floatingInput"
        placeholder="Code"
        v-model="form.code"
        required
      />
      <label for="floatingInput">Code</label>
    </div>

    <div class="btn-group mt-2" role="group" aria-label="Password Reset Button">
      <button type="button" @click="cancel" class="btn btn-warning">Cancel</button>
      <button type="submit" class="btn btn-primary">Validate</button>
    </div>
  </form>
</template>

<script>
import { ref } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'
export default {
  props: {
    username: {
      type: String,
      required: true
    }
  },
  emits: ['previous', 'next', 'resendCode'],
  setup (props, { emit }) {
    const router = useRouter()

    const form = ref({
      username: props.username,
      code: ''
    })

    const submit = async () => {
      const requestResult = await axios.post(
        process.env.VUE_APP_API_URL +
            '/users/validatepwdresetcode',
        form.value,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )

      const result = requestResult.data
      if (!result) {
        alert('Code is invalid.')
        return
      }

      emit('next', {
        nextComponent: 'ResetPwd',
        username: props.username,
        code: form.value.code
      })
    }

    const cancel = () => {
    //   emit('previous', {
    //     previousComponent: 'ValidateUsernameEmail'
    //   })
      router.push({ path: '/account/login' })
    }

    return {
      form,
      submit,
      cancel
    }
  }
}
</script>

<style>
</style>
